import { useEffect, useState } from "react";
import type { CapsuleOrganisation } from "../interfaces/CapsuleOrganisation";
import { Cross } from "./SVGs";

export const OrganisationSelect = ({
	className,
	onChange,
	filter,
	organisations,
}: {
	className: string;
	onChange: (orgName: string, filtered: boolean) => void;
	filter: string;
	organisations: CapsuleOrganisation[];
}) => {
	const [filterString, setFilterString] = useState(filter);

	useEffect(() => {
		if (filter === "") {
			setFilterString(filter);
		}
	}, [filter]);

	// NOTE: the `input` has `autocomplete` set to 'nope' instead of 'off'
	// because a random string (i.e. nope) works, whereas, 'off' no longer works in chromium based browsers...
	return (
		<div className={className}>
			<div className={"select"}>
				{filter !== "" ? (
					<div className="tooltip">
						<button
							title={""}
							onClick={() => onChange("", false)}
							type={"button"}
							className={"select-clear"}
						>
							<Cross />
						</button>
						<span className="tooltip-text">Clear Filter</span>
					</div>
				) : null}
				<input
					title={""}
					list={"select-options"}
					className={"select-input"}
					type={"text"}
					autoComplete="off"
					placeholder={"Filter Organisations..."}
					value={filterString}
					onChange={(e) => {
						const org = e.currentTarget.value;
						setFilterString(org);
						if (organisations.find((f) => f.name === org) != null) {
							onChange(org, true);
						}
					}}
				/>
				<datalist id={"select-options"}>
					{organisations.map((o) => {
						return (
							<option key={o.id} value={o.name}>
								{o.name}
							</option>
						);
					})}
				</datalist>
			</div>
		</div>
	);
};
